import { TradeMethodsPage } from 'features/trade-methods';

export const TechOperatorTradeMethodsPage: React.FC = () => (
  <TradeMethodsPage />
);
